<template>
  <div class="autocomplete" v-if="filterBackend || options.length > enableAutocompleteSize">
    <input ref="input" @input="onChange" :disabled="disabled" :value="value" :placeholder="placeholder" />
    <Icon class="autocomplete-icon" name="Search" />
  </div>
</template>

<script>
import Icon from '../Icon/Icon.vue';

export default {
  components: { Icon },
  props: {
    value: {
      type: String,
      default: '',
    },
    enableAutocompleteSize: {
      type: Number,
      default: 10,
    },
    filterBackend: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChange(e) {
      this.$emit('input', e.target.value);
    },
  },
  watch: {
    open() {
      this.$refs?.input?.focus();
    },
  },
};
</script>

<style lang="scss" scoped>
.autocomplete {
  position: relative;
  padding: 8px;
}

.autocomplete input {
  outline: none;
  border: none;
  border-bottom: 1px solid var(--track-color-bluegray-30);
  width: 100%;
  color: var(--track-color-bluegray-70);
}
.autocomplete-icon {
  position: absolute;
  top: 0;
  right: 0;
  fill: var(--track-color-bluegray-30);
}
</style>
